import React from "react";

export const Sobre = (props) => {
  return (
    <div id="about">
      <div className="container">
        <div className="row">
          <div className="col-xs-12 col-md-6">
            {" "}
            {/* <img src="img/about.jpg" className="img-responsive" alt="" />{" "} */}
            <div id="video_container">
            <video id="video"src="img/video_atise.mp4"  width="350" height="500" controls autoplay></video>
            </div>
          </div>
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2>Nós somos a atise</h2>
              <p>{props.data ? props.data.paragraph : "loading..."}</p>
              <h3>O que fazemos, e porquê gostamos do que fazemos.</h3>
              <div className="list-style">
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why.map((d, i) => (
                          <li key={`${d}-${i}`}>{d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
                <div className="col-lg-6 col-sm-6 col-xs-12">
                  <ul>
                    {props.data
                      ? props.data.Why2.map((d, i) => (
                          <li key={`${d}-${i}`}> {d}</li>
                        ))
                      : "loading"}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  );
};

